<template lang='pug'>
.container
  .video-panel(@click="videoStart")
    video(id="videobox" :poster="poster" ref="videobox" class="video-js" preload="auto" width="638" height="457" webkit-playsinline="true" playsinline="true" style="width=100%; height=100%; object-fill: fill")
      source(src="https://ydlunacommon-cdn.nosdn.127.net/1318946603c436e7dc24af6fbecde4f2.mp4",  type="video/mp4")
  img.banner(src="./../assets/img/banner.png")
  .condition
    img.sub-banner(src="./../assets/img/dictPen.png")
    img.title(src="./../assets/img/condition.png")
    .apply-condition(v-for="item in textList.condition" v-html="item.text")
    .apply-condition_important(v-for="item in textList.conditionImportance" v-html="item.text")
  .way
    .form-lock(v-if="status !== 1", @click="formLock($event)")
    img.title(src="./../assets/img/way.png")
    .info-import
      .name 您的姓名
      input.input-common(
        type="text",
        name="fname",
        v-show="!submited",
        placeholder='请填写教师证上的姓名',
        v-model="userName"
      )
      p.disabled(v-show="submited") {{userName}}
    .info-import
      .name 手机号码
      input.input-common(
        type="text",
        name="fname",
        v-show="!submited",
        placeholder='请输入您的手机号',
        v-model="phone"
      )
      p.disabled(v-show="submited") {{phone}}
    .info-import
      .name 所在学校
      input.input-common(
        type="text",
        name="fname",
        v-show="!submited",
        placeholder='省+市+学校名称',
        v-model="schoolName"
      )
      p.disabled(v-show="submited") {{schoolName}}
    .apply-way(v-for="item in textList.way" v-html="item.text")
    .way_important(v-for="item in textList.wayImportance" v-html="item.text")
    button.submit(@click="apply", v-show="!submited") 确认申请
    button.submit-disabled(v-show="submited") 已提交
</template>

<script>
/* eslint-disable */
import service from '@/service/index';
import videojs from 'video.js';

export default {
  name: 'LetterEnter',
  data() {
    return {
      phone: '',
      userName: '',
      popImg: require('@/assets/img/unopen.png'),
      popSuccImg: require('@/assets/img/submit.png'),
      schoolName: '',
      status: 1,
      submited: false,
      showPop: false,
      isPlay: false,
      player: {},
      wapPoster: 'https://ydlunacommon-cdn.nosdn.127.net/ab660041f5cc8a754543a6eb1d1d05cc.png',
      webPoster: 'https://ydlunacommon-cdn.nosdn.127.net/31f9e1f1507d238a7a81e703a61b339f.png',
      poster: '',
      textList: window.data
    };
  },
  created() {
    this.poster = window.ydk.isDesktop ? this.webPoster : this.wapPoster
    window.ydk.share({
      type   : "wechat",
      title  : "520围观丁磊表白！向全国英语老师免费赠送有道词典笔",
      desc   : "网易CEO丁磊的表白礼物！有道词典笔免费领取！",
      imgUrl : "https://ydlunacommon-cdn.nosdn.127.net/816e59bfbb21566c9ec554c5f184a8a1.png",
      shift: true,
      link   : window.location.href,
      silence: true
    });
    this.checkStart();
  },
  watch: {
    userName(newVal, oldVal) {
      if (newVal.length > 10) {
        this.userName = oldVal
        this.$toast.center({
          word: '已超出最大长度',
        });
      }
    }
  },
  mounted() {
  // 为避免在初始化video时播放源是空的，报播放源错误，需要先给source 的src赋值
    this.player = videojs('videobox', {
      controls: true,
      autoplay: false,
      loop: false,
      muted: false,
      fluid: true, // 自适应宽高（全屏）
      nativeControlsForTouch: true, // 修改了，在pc端单击暂停，但是在移动端无效的问题。
    },
    function onPlayerReady() {
      setTimeout(() => { // 延时确保能监听到视频源错误
        const mediaError = this.error();
        if (mediaError != null && mediaError.code) {
          this.$popup.open({
            type: 'alert', // center：页面中间， bottom: 底部弹窗、alert：确认弹窗
            title: '错误', // 弹窗标题
            descMessage: '视频资源错误', // 弹窗描述
            confirmButtonText: '确定', // 确认按钮文案
            confirm: () => {
            // 确认按钮回调
              this.$popup.close();
            },
          });
        }
      }, 1000);
    }
    );
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    videoStart() {
      if (this.isPlay) {
        this.player.pause();
      } else {
        this.player.play();
      }
      this.isPlay = !this.isPlay
    },
    checkStart() {
      service.checkStart().then((res) => {
        const status = res.info.actStatus
        this.status = status
        // this.status = 2
        this.handleActivityStatus(this.status)
        console.log(res);
      });
    },
    formLock(event) {
      event.stopPropagation();
      this.handleActivityStatus(this.status)
    },
    handleActivityStatus(status) {
      if (status === 2) {
        this.$popup.open({
          type: 'alert-qrcode', // center：页面中间， bottom: 底部弹窗、alert：确认弹窗
          title: '申请已结束', // 弹窗标题
          descMessage: '老师您好，本次活动申请已结束，您可以关注“<span>有道学习硬件</span>”微信服务号了解活动后续详情。', // 弹窗描述
          confirmButtonText: '确定', // 确认按钮文案
          confirm: () => {
          // 确认按钮回调
            this.$popup.close();
          },
        });
      }
    },
    checkPhone(phone) {
      if (/^1[3456789]\d{9}$/.test(phone)) {
        return false
      }
      return true
    },
    apply() {
      if (this.status === 0 || this.status === 2) {
        this.handleActivityStatus(this.status)
      } else {
        if(!this.$hasContent(this.userName)) {
          this.$toast.center({
            word: '请输入姓名',
          });
          return
        }
        if(!this.$hasContent(this.schoolName)) {
          this.$toast.center({
            word: '请添加学校',
          });
          return
        }
        if (this.userName === '') {
          this.$toast.center({
            word: '请输入姓名',
          });
        } else if (this.phone === '') {
          this.$toast.center({
            word: '请填写电话',
          });
        } else if(this.checkPhone(this.phone)) {
          this.$toast.center({
            word: '手机号格式有误',
          });
        } else if (this.schoolName === '') {
          this.$toast.center({
            word: '请添加学校',
          });
        } else {
          const param = {
            phone: this.phone,
            userName: this.userName,
            schoolName: this.schoolName,
            source: this.$route.query.channel
          };
          service.applyPen(param).then((res) => {
            this.submited = true
            this.$popup.open({
              type: 'alert-qrcode', // center：页面中间， bottom: 底部弹窗、alert：确认弹窗
              title: '申请提交成功！', // 弹窗标题
              descMessage: '您可以关注“<span>有道学习硬件</span>”微信服务号了解活动后续详情。', // 弹窗描述
              confirmButtonText: '确定', // 确认按钮文案
              confirm: () => {
              // 确认按钮回调
                this.$popup.close();
              },
            });
            console.log(res);
          });
        }
      }
    },
  },
};
</script>

<style scoped lang='stylus'>
@font-face 
  font-family 'FZLanTingHeiS-EL-GB'
  src url('./../assets/font/FZLTXHJW.TTF')
/deep/ .vjs-poster
  background-color transparent
/deep/ .video-js
  background-color transparent
/deep/ .vjs-tech
  border-radius 0.12rem !important
/deep/ .vjs-loading-spinner
  font-size 2.5em
  width 2em
  height 2em
  border-radius 1em
  margin-top -1em
  margin-left -1.5em
/deep/ .video-js .vjs-big-play-button
  display none !important
  width 108px
  height 108px
  top 0
  left 0
  right 0
  bottom 0
  margin auto
  border-radius 50%
  font-size 7em
  line-height 100px
/deep/ .vjs-paused .vjs-big-play-button,
/deep/ .vjs-paused.vjs-has-started .vjs-big-play-button
  display block
.container
  width 100%
  position relative
  overflow hidden
  padding-bottom 1.77rem
  background url(./../assets/img/bg.png) top center no-repeat, url(./../assets/img/bg-footer.png) center bottom no-repeat
  background-size 100%
  .condition, .way
    background #FFFFFF
    box-shadow 0 0.13rem 0.2rem 0 rgba(81, 24, 31, 0.08)
    border-radius 0.12rem
    margin 0 0.54rem
    padding-bottom 0.4rem
    padding-top 0.54rem
    position relative
    .form-lock
      position absolute
      left 0
      top 0
      bottom 0
      right 0
      z-index 100
    .apply-condition, .apply-condition_important, .apply-way, .way_important
      font-size 0.24rem
      font-family FZLanTingHeiS-EL-GB
      font-weight 400
      letter-spacing 0.017rem
      color #363841
      line-height 0.47rem
      margin 0 0.54rem 0.4rem 0.54rem
    .submit
      background: linear-gradient(90deg, #FF4E53, #FB3132);
    .submit-disabled
      background: linear-gradient(90deg, #A6A6A6, #9D9D9D);
    .submit, .submit-disabled
      width 4rem
      box-sizing border-box
      outline: none;
      border-radius 0.4rem
      padding 0.24rem 1.2rem
      border 0
      outline none
      font-weight 700
      font-size 0.38rem
      color #FFFFFF
      line-height 0.38rem
      margin 0.54rem auto 0.45rem
      display block
      overflow hidden
    .info-import
      margin 0 0.54rem 0.47rem
      height 0.6rem
      font-size 0
      position relative
      .name
        width 1.56rem
        height 0.6rem
        display inline-block
        font-size 0.31rem
        font-family HYQiHei
        font-weight normal
        color #6A6565
        line-height 0.6rem
        position absolute
        left 0
        right 0
      .input-common
        width 3.6rem
        border 1px solid rgba(85,78,79,0.7)
        -webkit-appearance none
        border-radius 0.1rem
        box-sizing border-box
        padding 0 0.3rem 0 0.3rem
        margin-left 1.56rem
        height 0.6rem
        display block
        font-size 0.28rem
        line-height 0.42rem
        text-align left
        letter-spacing 0.01rem
        overflow hidden
        background-color #fff
      .disabled
        display block
        width 3.5rem
        text-align left
        font-size 0.26rem
        font-family FZLanTingHeiS-L-GB
        font-weight 400
        color: #6A6565;
        outline none
        box-shadow none
        border 0.01rem solid rgba(85,78,79,0.7)
        border-radius 0.1rem
        background #DCDCDC
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        box-sizing border-box
        padding 0 0.3rem 0 0.3rem
        -webkit-appearance none
        line-height 0.6rem
        height 0.6rem
        margin-left 1.56rem
  .condition
    padding-top 0.2rem
    .title
      margin 0.6 0 0.46rem 0
  .way
    margin-top 0.82rem
  .video-panel
    box-shadow 0 0.13rem 0.2rem 0 rgba(81, 24, 31, 0.08)
    border 0.01rem solid #fff
    margin 4.02rem auto 0
    width 6.38rem
    height 4.57rem
    border-radius 0.12rem
    overflow hidden
    #videobox
      width 100%
      height 100%
      border-radius 0.12rem !important
      position relative
  .banner
    width 100%
    margin 1.21rem 0 0
  .sub-banner
    width 100%
  .title
    width 100%
    margin 0.2rem 0 0.46rem 0
</style>
